<!--
 * @FileDescription: 当前页 | 全部
-->
<template>
  <!--选择当前页  选择全部-->
  <yxt-table-column
    width="18"
    align="right"
    :fixed="fixed"
    clear-padding="left-right">
    <template slot="header">
      <yxt-dropdown trigger="click" @command="handleCommand">
        <span> </span>
        <yxt-dropdown-menu slot="dropdown">
          <yxt-dropdown-item command="current">{{ language().lbl_current_page }}</yxt-dropdown-item>
          <yxt-dropdown-item command="all">{{ language().lbl_select_all }}</yxt-dropdown-item>
          <yxt-dropdown-item command="delAll">{{ language().lbl_clear_all }}</yxt-dropdown-item>
        </yxt-dropdown-menu>
      </yxt-dropdown>
    </template>
  </yxt-table-column>
</template>

<script>
export default {
  inject: ['language'],
  props: {
    fixed: {
      type: String,
      default: 'left'
    }
  },
  methods: {
    handleCommand(command) {
      this.$emit('handleCommand', command);
    }
  }
};
</script>
